<app-layout-dialogheader1 [title]="title" [titlesub]="titlesub" mat-dialog-title></app-layout-dialogheader1>

<mat-dialog-content>

    <app-ex-supervis-edit #editform [supervision]="model" [ismodal]="true" [isnewmodel]="true"></app-ex-supervis-edit>


</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">
    <button mat-raised-button type="button" (click)="saveModel()" [disabled]="!isvalid()||submitted"
        class="btn btn-success pull-right"><i class="far fa-save"></i> Save</button>
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>

<!-- [disabled]="!editform.myform.valid||submitted" -->